import React, { useState, useEffect, useContext } from "react";
import { withStyles } from '@material-ui/core/styles';
import configData from '../../../config/config.json';
import Dialog from '@material-ui/core/Dialog';
import { Grid, Button } from "@material-ui/core";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlane } from "@fortawesome/free-solid-svg-icons";
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Carousel from "react-material-ui-carousel";
import CircularProgress from "@material-ui/core/CircularProgress";
import  LocationOnIcon  from "@material-ui/icons/LocationOn";
import StarIcon from "@material-ui/icons/Star";
import ThumbUp from "@material-ui/icons/ThumbUp";
import { withTranslation } from 'react-i18next';
import { getDirection } from '../../../hooks/useDirection';

const DialogContent = withStyles((theme) => ({
    root: {
      padding: theme.spacing(0),
      backgroundColor:'#eee'
    },
}))(MuiDialogContent);
  
const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(1),
    },
}))(MuiDialogActions);


const API_ENDPOINT = configData.API_ENDPOINT;
//const [imageLoading, setImageLoading] = useState(false);
//const [counter, setCounter] = useState(1);

class SimpleDialog extends React.Component {

    //{ onClose, properties, packageUid, originalPropertyUID, originalPropertyInventoryUID, open, packagePricePP} = props;

    constructor(props){
        super(props);

        console.log('Constructor')
        this.state = {
            imageLoading: false,
            counters: [],
            loadingPropertyUID: null, // Added state
        };

        const propertyImagesArray = [];

        this.props.properties.forEach((property, index) => {
            propertyImagesArray.push(1);
        });

        this.setState({
            counters: propertyImagesArray
        },()=>{
            console.log(this.state.counters)
        });
        
    }

    componentDidUpdate(prevProps) {
        if (this.props.properties !== prevProps.properties) {
            console.log('Change Property Popup')
            const propertyImagesArray = [];

            this.props.properties.forEach((property, index) => {
                propertyImagesArray.push(1);
            });

            this.setState({
                counters: propertyImagesArray
            });
        }
    }


    handleClose = () => {
        this.props.onClose();
    };

    changeProperty = async (e, propertyInventoryUIDs) => {
        e.preventDefault();

        this.setState({ loadingPropertyUID: propertyInventoryUIDs });

        // Use the propertyInventoryID to make an axios call to:
        console.log(`changePropertyBtn`)
        let url = `${API_ENDPOINT}/search/packages/${this.props.packageUid}/properties/${propertyInventoryUIDs}`

        await axios.get(
            url,
            {
              headers: {
                'Content-Type': 'application/json'
              },
              withCredentials: true  
            }
          ).then(res=>{

            if (!res.data || res.data=='')  {
                console.error('COULD NOT FIND PROPERTY INVENTORY UID')
                alert(this.props.t('package.modals.error.title'))
                return
            }
            
            let redirect_url = window.location.href;  
            console.log(`old url: ${redirect_url}`)
            redirect_url = redirect_url.replace(this.props.packageUid, res.data)
            console.log(`new url: ${redirect_url}`)

            window.location.href = redirect_url;
          }).catch(err=>{
            console.log(err)
            alert(this.props.t('package.modals.error.title'))
            this.setState({ loadingPropertyUID: null });
          });

          //alert(resPackage.data)

    }

    handleImageChange = (propertyIndex, index) => {
        const arr = this.state.counters;
        arr[propertyIndex] = index + 1;
        this.setState({
            imageLoading:true,
            counters: arr
        });
    };
      
    render() {
        // Search the properties array for a record whose property?.inventory_uid == originalPropertyInventoryUID and place it as the first item in the array
        const property = this.props.properties.find(property => property?.uid == this.props.originalPropertyUID)
        
        // remove the property of the existing package
        let propertiesArray =  this.props.properties.filter(property => property?.uid != this.props.originalPropertyUID);

        // add this property property as the first item in the properties array
        if (property)
            propertiesArray.unshift(property);

        // if we're in the change meal plan modal - cleanup the array (because we only want to show the existing hotel)
        if (this.props.changeMealPlanOnly) {
            propertiesArray = this.props.properties.filter(property => property?.uid == this.props.originalPropertyUID)
        } 

        return (
                <Dialog className="change-property-dialog" fullScreen aria-labelledby="simple-dialog-title" open={this.props.open} scroll="paper" id="change_property" onClose={this.handleClose}>
                    <AppBar className="change-property-appbar">
                            <Toolbar className="change-property-toolbar" tabIndex={0}>
                                <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h5" className="change-property-title-text">
                                    {this.props?.changeMealPlanOnly?this.props.t('package.modals.changeProperty.mealPlanTitle'):this.props.t('package.modals.changeProperty.title')}
                                </Typography>
                                <Box component="span" m={2}></Box>
                            </Toolbar>
                    </AppBar>
                    <DialogContent>
                        {this.props.properties && this.props.properties.length > 1 ? (
                            <div className='ugly modalBody'  >
                
                                <Grid container>
                                    <Grid item className='text-center' xs={12}>
                                        {propertiesArray.map((property,propertyIndex) => {

                                            
                                        

                                            let propertyUID = property.uid;
                                            let propertyName = property.name;
                                            //let propertyCityName = property?.city_name;
                                            let propertyAreaName = property.area_name;
                                            let propertyDescription = property?.description;
                                            let propertyAddress = property.address;
                                            let propertyCityName = this.props?.cityName;
                                            let propertyStars = property.stars;
                                            let propertyRating = property.rating;
                                            let propertyReviewsCount = property.reviews_count;
                                            let propertyDistanceFromCenter = property.distance_from_center;
                                            let propertyLAT = property.lat;
                                            let propertyLNG = property.lng;
                                            let propertyCheckinTime = property.checkin_time;
                                            let propertyCheckoutTime = property.checkout_time;
                                            let propertyHasPool = property.attributes.has_pool;
                                            let propertyHasCasino = property.attributes.has_casino;
                                            let propertyHasSpa = property.attributes.has_spa;
                                            let propertyHasIndoorPool = property.attributes.has_indoor_pool;
                                            let propertyHasSkiDoor = property.attributes.has_ski_door;
                                            let propertyHasWaterPark = property.attributes.has_waterpark;
                                            let propertyIsFamilyFriendly = property.attributes.is_family_friendly;
                                            let propertyIsFavorable = property.attributes.is_favorable;
                                            let propertyIsKosher = property.attributes.is_kosher;
                                            let propertyIsNearChabad = property.attributes.is_near_chabad;
                                            let propertyIsLuxury = property.attributes.is_luxury;
                                            let propertyIsRomantic = property.attributes.is_romantic;
                                            let propertyPhotos = property.photos;
                                            //let propertyInventory = property.inventory;
                                            let propertyOptions = property.options;
                                            let ratingArr = [1, 2, 3, 4, 5, 6];

                                            
                                            /*
                                            const isOriginalProperty = originalPropertyInventoryUID == property?.inventory_uid;
                                            if (isOriginalProperty)
                                                priceChangeCaption = this.props.t('package.modals.changeProperty.includedFlight');
                                            */
                                            const isOriginalProperty =false;
                                            let first = 0;
                                            
                                            return  (
                                            <>
                                                <div className={this.props.changeMealPlanOnly?'hidden':'property-section-header'}>
                                                    {propertyIndex==0?(<h3 className="property-section-heading">{this.props.t('package.modals.changeProperty.currentHotel')}</h3>):propertyIndex==1?(<h3 className="property-section-heading">{this.props.t('package.modals.changeProperty.otherHotels')}</h3>):''}
                                                </div>
                                                <div className={isOriginalProperty?"card property-card-original":"card property-card-alternative"} key={'item'+propertyIndex} onClick={propertyIndex==0?this.handleClose:null}>
                                                    
                                                    <div>
                                                        <div className={this.props?.changeMealPlanOnly?"content hidden":"content property-details-content"}>
                                                                <center>
                                                                    <h3 className="property-name-ltr">{propertyName}</h3>
                                                                    <p className="property-address-ltr">{propertyAddress} {propertyAreaName} {propertyCityName}</p>
                                                                </center>
                                                                <div className="carrousalBody property-carousel" dir="rtl">
                                                                    <Carousel
                                                                        dir="rtl"
                                                                        onChange={(index) => this.handleImageChange(propertyIndex, index)}
                                                                        navButtonsProps={{
                                                                            // Change the colors and radius of the actual buttons. THIS STYLES BOTH BUTTONS
                                                                            style: {
                                                                                color: "#666666",
                                                                                backgroundColor: "#ffffffcf",
                                                                                borderRadius: 0,
                                                                                margin: 0,

                                                                            },
                                                                        }}
                                                                        indicatorIconButtonProps={{
                                                                            style: {
                                                                                display: "none", // 3
                                                                            },
                                                                        }}
                                                                        stopAutoPlayOnHover={true}
                                                                        autoPlay={false}
                                                                        swipe={true}
                                                                        
                                                                        animation="slide"
                                                                        navButtonsAlwaysVisible="true"
                                                                        NextIcon={<div title={this.props.t('package.modals.changeProperty.nextImage')} className="carousel-nav-icon">{getDirection(this.props.i18n.language) === 'rtl' ? '\u203A' : '\u2039'}</div>}
                                                                        PrevIcon={<div title={this.props.t('package.modals.changeProperty.prevImage')} className="carousel-nav-icon">{getDirection(this.props.i18n.language) === 'rtl' ? '\u2039' : '\u203A'}</div>}
                                                                    >
                                                                        {propertyPhotos.map((item, i) => (
                                                                            <div className="carrousalDiv text-center" key={'carrousel_item'+i}>
                                                                                <div className="carousalImage" style={{background:`url(${"https://cdn.cookiecrumbz.com/images/properties/600/"+item.filename})`}} title={this.props.t('package.modals.changeProperty.imageGallery')}></div>
                                                                            </div>
                                                                        ))}
                                                                    </Carousel>
                                                                    <span className="imgCounter property-image-counter" title={this.props.t('package.modals.changeProperty.imageCount', { count: propertyPhotos.length })}>
                                                                        {this.state.counters[propertyIndex]}/{propertyPhotos.length}
                                                                    </span>
                                                                </div>
                                                                

                                                                <div className="property-stats-row">

                                                                    <div className="property-stat-item">
                                                                        <ThumbUp title={this.props.t('package.modals.changeProperty.guestRating')} className="property-stat-icon" /><br />
                                                                        {propertyRating?propertyRating:4}/5 <br /> {this.props.t('package.modals.changeProperty.guestRating')}
                                                                    </div>

                                                                    <div className="property-stat-item">
                                                                        <LocationOnIcon title={this.props.t('package.modals.changeProperty.viewMap')} className="property-stat-icon-location" /><br />
                                                                        <label className="hidden-label">{this.props.t('package.modals.changeProperty.distanceFromCenter')} {propertyDistanceFromCenter<1?propertyDistanceFromCenter*1000+' '+this.props.t('common.units.meters'):(propertyDistanceFromCenter*1).toFixed(1) + ' '+this.props.t('common.units.km')}</label>
                                                                        {propertyDistanceFromCenter<1?propertyDistanceFromCenter*1000+' '+this.props.t('common.units.meters'):(propertyDistanceFromCenter*1).toFixed(1) + ' '+this.props.t('common.units.km')} <br /> {this.props.t('hotel.fromCenter')}
                                                                    </div>

                                                                    <div>
                                                                            {/* <Rating disabled name="size-small" defaultValue={stars} /> */}
                                                                            {ratingArr?.map((item, index) => {
                                                                                if (index < propertyStars) {
                                                                                return (
                                                                                    <StarIcon key={index+'stars'}
                                                                                    className="property-star-icon"
                                                                                    />
                                                                                );
                                                                                }
                                                                            })}
                                                                            <br />
                                                                            <label>{this.props.t('hotel.stars', { count: propertyStars })}</label>
                                                                    </div>
                                                                </div>

                                                                <div className={
                                                                    propertyHasWaterPark || propertyIsKosher || propertyIsLuxury || propertyHasCasino || propertyHasSpa || propertyHasIndoorPool || propertyHasPool || propertyIsFamilyFriendly || propertyIsNearChabad?
                                                                        "amenities flex flex-wrap gap-1 text-sm mt-1 rtl mb-3 property-amenities":"amenities flex flex-wrap gap-1 text-sm mt-1 rtl mb-3 hidden"}>

                                                                    {propertyHasWaterPark?
                                                                        (<div className="flex items-center gap-1 bg-gray-100 px-3 py-1 rounded amenity-badge">
                                                                        🌊 <span>{this.props.t('package.modals.changeProperty.amenities.waterpark')}</span>
                                                                    </div>):''}
                                                                    {propertyIsKosher?
                                                                        (<div className=" items-center gap-1 bg-gray-100 px-3 py-1 rounded amenity-badge">
                                                                        🍽️ <span>{this.props.t('package.modals.changeProperty.amenities.kosher')}</span>
                                                                    </div>):''}
                                                                    {propertyIsLuxury?
                                                                        (<div className=" items-center gap-1 bg-gray-100 px-3 py-1 rounded amenity-badge">
                                                                        💎 <span>{this.props.t('package.modals.changeProperty.amenities.luxury')}</span>
                                                                    </div>):''}
                                                                    {propertyHasCasino?
                                                                        (<div className="items-center gap-1 bg-gray-100 px-3 py-1 rounded amenity-badge">
                                                                            🎰 <span>{this.props.t('package.modals.changeProperty.amenities.casino')}</span>
                                                                        </div>):''}
                                                                    {propertyHasSpa?
                                                                        (<div className=" items-center gap-1 bg-gray-100 px-3 py-1 rounded amenity-badge">
                                                                            🧖 <span>{this.props.t('package.modals.changeProperty.amenities.spa')}</span>
                                                                        </div>):''}
                                                                    {propertyHasIndoorPool?
                                                                        (<div className=" items-center gap-1 bg-gray-100 px-3 py-1 rounded amenity-badge">
                                                                        🏊‍♂️ <span>{this.props.t('package.modals.changeProperty.amenities.indoorPool')}</span>
                                                                    </div>):''}
                                                                    {propertyHasPool?
                                                                        (<div className=" items-center gap-1 bg-gray-100 px-3 py-1 rounded amenity-badge">
                                                                        🏖️ <span>{this.props.t('package.modals.changeProperty.amenities.pool')}</span>
                                                                    </div>):''}
                                                                    {propertyIsFamilyFriendly?
                                                                        (<div className=" items-center gap-1 bg-gray-100 px-3 py-1 rounded amenity-badge">
                                                                        👨‍👩‍👧 <span>{this.props.t('package.modals.changeProperty.amenities.familyFriendly')}</span>
                                                                    </div>):''}
                                                                    {propertyIsNearChabad?
                                                                        (<div className=" items-center gap-1 bg-gray-100 px-3 py-1 rounded amenity-badge">
                                                                        🕍 <span>{this.props.t('package.modals.changeProperty.amenities.nearChabad')}</span>
                                                                    </div>):''}

                                                                    {/*propertyHasWaterPark || propertyIsKosher || propertyIsLuxury || propertyHasCasino || propertyHasSpa || propertyHasIndoorPool || propertyHasPool || propertyIsFamilyFriendly || propertyIsNearChabad ?
                                                                    (<div class="flex items-center gap-1 bg-gray-100 px-2 py-1 rounded"  style={{ border: '1px solid #555'}}>
                                                                        🔥 <span>{this.props.t('package.modals.changeProperty.requestedHotel')}</span>
                                                                    </div>):
                                                                    (<div class="flex items-center gap-1 bg-gray-100 px-2 py-1 rounded"  style={{ border: '1px solid #555'}}>
                                                                        🏅 <span>{this.props.t('package.modals.changeProperty.recommendedHotel')}</span>
                                                                    </div>)*/}
                                                                </div>
                                                                    

                                                        </div>
                                                        <div>
                                                            {propertyOptions.map((option, index) => {
                                                                
                                                                let optionMealPlanCode = option.meal_plan_code;
                                                                let optionMealPlanName = this.props.t('package.modals.changeProperty.mealPlans.roomOnly'); 

                                                                // accummulate all iventory array item's price
                                                                let inventoryPrice = option.price;
                                                                let inventoryPricePP = option.price_pp;
                                                                //let inventoryUID = inventory.inventory_uid;
                                                                let inventoryUIDs = option.inventory.map(item=>item.uid).toString();
                                                                

                                                                let priceDeltaPP = inventoryPricePP-this.props.packagePricePP;
                                                                if (priceDeltaPP > 0)
                                                                    priceDeltaPP = Math.ceil(priceDeltaPP)
                                                                else
                                                                    priceDeltaPP = Math.floor(priceDeltaPP)

                                                                let priceChangeCaption;
                                                                let priceDeltaText = '';

                                                                if (priceDeltaPP*1 == 0) {
                                                                    priceChangeCaption = this.props.t('package.modals.changeProperty.noChange')
                                                                } else {
                                                                    priceDeltaText = priceDeltaPP>0?`+$${priceDeltaPP}`:`-$${Math.abs(priceDeltaPP)}`;
                                                                    if (priceDeltaPP>0)
                                                                        priceChangeCaption = this.props.t('package.modals.changeProperty.priceIncrease', { price: priceDeltaPP });
                                                                    else
                                                                        priceChangeCaption = this.props.t('package.modals.changeProperty.priceSaving', { price: priceDeltaPP*-1 });
                                                                }

                                                                switch(optionMealPlanCode){
                                                                        case 'BB':optionMealPlanName = this.props.t('hotel.mealPlans.breakfast');break;
                                                                        case 'HB':optionMealPlanName = this.props.t('hotel.mealPlans.halfBoard');break;
                                                                        case 'FB':optionMealPlanName = this.props.t('hotel.mealPlans.fullBoard');break;
                                                                        case 'AI':optionMealPlanName = this.props.t('hotel.mealPlans.allInclusive');break;
                                                                        case 'RO':optionMealPlanName = this.props.t('package.modals.changeProperty.mealPlans.roomOnly');break;
                                                                        default:optionMealPlanName = this.props.t('package.modals.changeProperty.mealPlans.roomOnly');break;
                                                                    }
                                                                //let inventoryCheckinDate = option.checkin_date;
                                                                //let inventoryCheckoutDate = option.checkout_date;

                                                                return (
                                                                    <>
                                                                    <hr />
                                                                    <Grid container alignItems="stretch" justifyContent="space-evenly" alignContent="center" tabIndex={4} className="property-option-row">
                                                                        <Grid item xs={4}>
                                                                            <div className="property-meal-plan-name">
                                                                                {optionMealPlanName}
                                                                            </div>
                                                                        </Grid>
                                                                        <Grid item xs={5}>
                                                                            <div className="property-price-info">
                                                                                {inventoryUIDs == this.props.originalPropertyInventoryUIDs ?
                                                                                        (<>
                                                                                            <p className="property-included-text">{this.props.t('package.modals.changeProperty.includedInPrice')}</p>
                                                                                        </>) :
                                                                                        (<>
                                                                                            <h3 className={inventoryUIDs != this.props.originalPropertyInventoryUIDs && first++==0?"property-price-delta-primary":"property-price-delta-secondary"}>{priceDeltaText}</h3>
                                                                                            <p className="property-price-caption">{priceChangeCaption}</p>
                                                                                        </>
                                                                                        )
                                                                                }
                                                                            </div>
                                                                        </Grid>
                                                                        <Grid item xs={3}>
                                                                            <div className="property-select-button-container">

                                                                                {inventoryUIDs == this.props.originalPropertyInventoryUIDs ? (
                                                                                    <p className="property-included-hidden"><strong>{this.props.t('package.modals.changeProperty.includedInPrice')}</strong></p>
                                                                                ) : (
                                                                                    <Button
                                                                                        className="property-select-button"
                                                                                        onClick={(e) => this.changeProperty(e, inventoryUIDs)}
                                                                                        disabled={this.state.loadingPropertyUID === inventoryUIDs}
                                                                                    >
                                                                                        {this.state.loadingPropertyUID === inventoryUIDs ? (
                                                                                            <CircularProgress size="1rem" className="button-loading-spinner" />
                                                                                        ) : (
                                                                                            this.props.t('package.modals.changeProperty.selectButton')
                                                                                        )}
                                                                                    </Button>
                                                                                )}

                                                                            </div>
                                                                        </Grid>
                                                                    </Grid>
                                                                    </>
                                                                )
                                                            }
                                                            )}
                                                        </div>
                                                        {/*
                                                        <div style={(isOriginalProperty)?
                                                            {display:'none'}:
                                                            {display:'block'}}>
                                                            <button style={{backgroundColor:'#1e5881', color:'#fff', borderRadius:'5px', border:'none', padding:'.35em .6em', fontWeight:600}} onClick={e=>changeProperty(e, null)}>{this.props.t('package.modals.changeProperty.title')}</button>
                                                        </div>
                                                        */}
                                                    </div>
                                                </div>
                                            </>
                                        )})}
                                    </Grid>    
                                </Grid>
                                <Grid container>
                                    <Grid item xs={12}>
                                        {propertiesArray.length <= 1 && !this.props?.changeMealPlanOnly? (<div className="no-other-hotels-message"><h3 align="center" className="no-other-hotels-heading">
                                            {this.props.t('package.modals.changeProperty.noOtherHotels')}</h3></div>) : ''}
                                    </Grid>
                                </Grid>
                            </div>
                        ):(<p className="loading-spinner-container"><CircularProgress size="2.5rem" className="loading-spinner-primary"></CircularProgress></p>)}
                    </DialogContent>
        
                </Dialog>
        );
    }

 
}

export default withTranslation()(SimpleDialog);